import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const WA_LINK = "https://wa.me/393296281756?text=Ciao%20Danielealoisi%2C%20vorrei%20un%20preventivo%2Fsopralluogo%20per%20infissi%20o%20lavorazioni%20in%20ferro.%20Zona%3A%20_____%20.%20Posso%20inviare%20alcune%20foto.";

const zones = ["Roma Est", "Tiburtina", "Guidonia Centro", "Setteville", "La Botte"];

const ZonesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} className="section-light py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-section-light-foreground">
            Zone servite
          </h2>
          <p className="mt-4 text-section-light-foreground/60 font-body max-w-lg mx-auto">
            Roma, Guidonia e La Botte (RM). Scrivici la tua zona: ti confermiamo disponibilità e tempistiche.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-8 flex flex-wrap justify-center gap-3"
        >
          {zones.map((zone) => (
            <span
              key={zone}
              className="px-5 py-2 border border-section-light-foreground/15 rounded-full text-sm font-body text-section-light-foreground/70 hover:border-accent hover:text-accent transition-colors duration-300"
            >
              {zone}
            </span>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-10"
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm tracking-widest uppercase font-body bg-[#25D366] text-white rounded-sm hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300"
          >
            Scrivi su WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ZonesSection;